module.exports = __webpack_public_path__ + "components/MapControl/svg/Kirkut.svg?b492ec50";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kirkut.svg
// module id = 1944
// module chunks = 0